import { observable, action } from 'mobx'
import { Help } from 'src/store/NavigationStore/types'

class NavigationStore {
  @observable
  unFoldMenu: boolean
  @observable
  blueMenu: boolean
  @observable
  title: string
  @observable
  helps: Help[]
  @observable
  showHelpPanel: boolean

  constructor() {
    this.unFoldMenu = false
    this.blueMenu = false
    this.title = ''
    this.helps = []
  }

  @action
  setMenu = ({
    unFoldMenu,
    blueMenu,
  }: {
    unFoldMenu: boolean
    blueMenu: boolean
  }) => {
    this.blueMenu = blueMenu
    this.unFoldMenu = unFoldMenu
  }

  @action
  setTitle = (value: string) => {
    this.title = value
  }

  @action
  setHelps = (help: Help[]) => {
    this.helps = help
  }

  @action
  toggleHelpPanel = () => {
    this.showHelpPanel = !this.showHelpPanel
  }

  @action
  closeHelpPanel = () => {
    this.showHelpPanel = false
  }
}

export default NavigationStore



// WEBPACK FOOTER //
// ./src/store/NavigationStore/index.ts